module.exports = __webpack_public_path__ + "static/media/easybib-chegg-logo.c9048868.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/easybib-chegg-logo.svg
// module id = 5748
// module chunks = 11